import React from "react";
import ViewForm from "./components/ViewForm";
import { API_URLS } from "../../../../api/apiUrls";

const ViewDynamicForm = () => {
  return (
    <div className="h-full px-5 pb-5 ">
      <ViewForm
        sectionurl={API_URLS.CUSTOMFORM_SECTIONS}
        subsectionurl={API_URLS.CUSTOMFORM_SUBSECTIONS}
        questionurl={API_URLS.CUSTOMFORM_QUESTIONS}
      />
    </div>
  );
};

export default ViewDynamicForm;
